import '../../css/sidebar_header.css';
import Header from '../Header/Header';
import AppointmentRequestPage from '../AppointmentRequestPage/AppointmentRequest';
export default function PatientDashboardPage() {

    return (
        <div className="min-h-screen bg-[#edeef2]">
            <Header />
            <main
                className={`
                    pt-[30px]
                    transition-all duration-300
                    md:ml-2
                `}
            >
                <div className="p-4 sm:p-6">
                    <AppointmentRequestPage />
                </div>
            </main>
        </div>
    );
}